import { render, staticRenderFns } from "./PaymentAttributeDetailEdit.vue?vue&type=template&id=f43b015a"
import script from "../../controllers/payment_att_detail/payment-attribute-detail-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_att_detail/payment-attribute-detail-edit.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeDetailEdit.vue?vue&type=style&index=0&id=f43b015a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports